export interface IVisioRequestQueryResult {
  total: number;
  requests: IVisioRequest[];
}

export interface Csr {
  readonly uuid: string;
  readonly login: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly lowerLogin: string;
  readonly lowerFirstName: string;
  readonly lowerLastName: string;
}

export interface IVisioRequest {
  readonly uuid: string;
  readonly idContact: string;
  readonly contactFirstName: string;
  readonly contactLastName: string;
  readonly lowerContactFirstName: string;
  readonly lowerContactLastName: string;
  readonly startDate: string;
  readonly endDate: string;
  readonly phoneNumber: string;
  readonly status: string;
  readonly csr: Csr;
  readonly participants: Csr[];
  readonly awaitingParticipants: Csr[];
  readonly refusingParticipants: Csr[];
  readonly skillList: string[];
  readonly comment: string;
  readonly targets: string[];
  readonly reason: string;
  readonly recycled: boolean;
  readonly type: string;
  readonly flowUuid: string;
  readonly campaignUuid: string;
}

export enum BasketVisioLabels {
  ALL = 'ALL',
  CONFIRMED = 'CONFIRMED',
  REQUESTED = 'REQUESTED',
  CANCELLED = 'CANCELLED',
  ASSIGNABLE = 'ASSIGNABLE',
  REQUEST_CANCELLED = 'REQUEST_CANCELLED',
}
